module.exports = __webpack_public_path__ + "images/6d2b4a9e234e1ab9a1c235f83cb0b138.jpg";